import React, { useContext, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getActiveBook } from '../../NecttosComp/APICaller/ApiServices';
import moment from 'moment';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Instruction from '../../Documentation/Instruction';
import Input2 from '../../NecttosComp/Input/Input2';

export const ActiveRegister = ({ onClose }) => {
	const [loading, setLoading] = useState(false);
	const [state, setState] = useState({ filterValue: '', page: 0 });

	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();

	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const { data: activeBook, refetch } = useQuery(['activeBookData', state.page], getActiveBook({ collegeId, state, setLoading }));
	const issuedData = activeBook?.issuedData || {};
	const rawData = issuedData?.data || [];
	const filteredData = rawData.filter((item) => {
		const filter = state.filterValue?.toLowerCase() || '';
		return (
			String(item.title || '')
				.toLowerCase()
				.includes(filter) ||
			String(item.author || '')
				.toLowerCase()
				.includes(filter) ||
			String(item.accessionNumber || '')
				.toLowerCase()
				.includes(filter)
		);
	});

	return (
		<Main height='100%' width='100%' title='Active Register'>
			<Header className='w-full px-4 py-3 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700'>
				<div className='w-full flex flex-col gap-4 lg:flex-row justify-between items-start lg:items-center flex-wrap'>
					<div className='flex flex-col sm:flex-row items-start sm:items-center gap-2 flex-shrink-0'>
						<Input2
							className='w-full sm:w-[580px]'
							returnKey='filterValue'
							fieldName='Search By Title, Author, Accession No'
							state={state}
							setState={(newState) => {
								setState({ ...state, ...newState, page: 0 });
								refetch();
							}}
							type='text'
						/>
						<div className='flex items-center gap-2'>
							<Button type='save' disabled={parseInt(state.page) < 1} onClick={() => setState({ ...state, page: parseInt(state.page) - 1 })}>
								Prev
							</Button>
							<span className='text-sm text-gray-700 dark:text-gray-300 whitespace-nowrap'>
								Showing {parseInt(state.page) * 30} - {parseInt(state.page) * 30 + 30} of {issuedData?.total?.[0]?.total}
							</span>
							<Button type='save' disabled={parseInt(state.page) * 30 > parseInt(issuedData?.total?.[0]?.total) - 30} onClick={() => setState({ ...state, page: parseInt(state.page) + 1 })}>
								Next
							</Button>
						</div>
					</div>

					<div className='flex flex-wrap gap-2 sm:gap-4 flex-shrink-0'>
						<Button type='fetch' onClick={() => refetch()}>
							Reload
						</Button>
						<Button type='print' tableRef={componentRef.current}>
							Print
						</Button>
						<Instruction keyId={'activeRegister'} />
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</div>
			</Header>

			<Body>
				<div ref={componentRef} className='printable bg-slate-100 dark:bg-neutral-800 rounded-lg '>
					<div className='flex flex-col rounded-[25px] p-4 gap-4'>
						<div className='flex flex-col md:flex-row items-center gap-4'>
							<img src={selectedCollege?.logo} className='w-[60px] h-[60px] md:w-[12%] md:h-auto object-contain' />
							<div className='text-center md:text-left flex-1'>
								<h1 className='text-2xl font-bold dark:text-slate-100'>{selectedCollege?.collegeShortName}</h1>
								<p className='text-lg font-semibold dark:text-slate-100'>{selectedCollege?.accreditedGrade}</p>
								<p className='text-sm font-medium dark:text-slate-100'>
									{selectedCollege?.address}, Phone: {selectedCollege?.phoneNumber}
								</p>
							</div>
						</div>
						<div className='w-full overflow-x-auto'>
							<div className='min-w-[900px]'>
								<Table width='100%' innerWidth={['4%', '8%', '20%', '12%', '12%', '6%', '4%', '8%', '12%', '10%', '10%']}>
									<Thead>
										<Tr>
											<Th position={0}>Sn</Th>
											<Th position={1}>Acc No</Th>
											<Th position={2}>Title</Th>
											<Th position={3}>Author</Th>
											<Th position={4}>DateTime</Th>
											<Th position={5}>Days</Th>
											<Th position={6}>Fine</Th>
											<Th position={7}>Mn No</Th>
											<Th position={8}>Class/Dept.</Th>
											<Th position={9}>Mn Name</Th>
											<Th position={10}>Issued By</Th>
										</Tr>
									</Thead>
									<Tbody height='65vh'>
										{filteredData.map((item, i) => (
											<Tr key={item._id} index={i}>
												<Td position={0} index={i}>
													{item.sn}
												</Td>
												<Td position={1} index={i}>
													{item.accessionNumber}
												</Td>
												<Td position={2} index={i} fontSize='11px'>
													{item.title}
												</Td>
												<Td position={3} index={i} fontSize='11px'>
													{item.author}
												</Td>
												<Td position={4} index={i} fontSize='11px'>
													{moment(item.tookOn).format('DD MMM YYYY hh:mm A')}
												</Td>
												<Td position={5} index={i}>
													{item.days}
												</Td>
												<Td position={6} index={i}>
													{item.fine}
												</Td>
												<Td position={7} index={i}>
													{item.admisionNo}
												</Td>
												<Td position={8} index={i}>
													{item.className}
												</Td>
												<Td position={9} index={i} fontSize='11px'>
													{item.issuedTo}
												</Td>
												<Td position={10} index={i} fontSize='11px'>
													{item.issuedBy}
												</Td>
											</Tr>
										))}
									</Tbody>
								</Table>
							</div>
						</div>

						<h5 className='mt-4 text-right text-xs dark:text-slate-100'>Seal & Signature {moment(new Date()).format('DD MMM YYYY hh:mm A')}</h5>
					</div>
				</div>
			</Body>
		</Main>
	);
};
